/* eslint-disable @typescript-eslint/unbound-method */

import { Injectable } from '@angular/core';
import { AbstractControl, ValidatorFn, Validators } from '@angular/forms';
import { InputItemBaseModel, InputItemModel } from '@libs/form/models';
import { CheckboxesValidator, DateFilterValidator, DatetimeValidator, FileCountValidator, FileValidator, PostalCodeValidator } from './custom';

@Injectable({
  providedIn: 'root',
})
export class ValidatorService {
  public attachControlValidators(control: AbstractControl, item: InputItemModel): void {
    this.addValidators(control, item);
    control.updateValueAndValidity({ emitEvent: false });
  }

  private addValidators(control: AbstractControl, item: InputItemModel): void {
    this.addEmailValidator(control, item);
    this.addMaxLengthValidator(control, item);
    this.addMinLengthValidator(control, item);
    this.addPatternValidator(control, item);
    this.addRequiredValidator(control, item);
    this.addPostalCodeValidator(control, item);
    this.addMinValidator(control, item);
    this.addMaxValidator(control, item);
    this.addDateValidator(control, item);
    this.addFileValidator(control, item);
    this.addFileMinCountValidator(control, item);
  }

  private addEmailValidator(control: AbstractControl, item: InputItemBaseModel): void {
    if (item.type === 'email') {
      control.addValidators(Validators.email);
    }
  }

  private addMaxLengthValidator(control: AbstractControl, item: InputItemBaseModel): void {
    if (item.attributes?.maxLength !== undefined) {
      control.addValidators(Validators.maxLength(item.attributes.maxLength));
    }
  }

  private addMinLengthValidator(control: AbstractControl, item: InputItemBaseModel): void {
    if (item.attributes?.minLength !== undefined) {
      control.addValidators(Validators.minLength(item.attributes.minLength));
    }
  }

  private addPatternValidator(control: AbstractControl, item: InputItemBaseModel): void {
    if (item.attributes?.pattern !== undefined) {
      control.addValidators(Validators.pattern(item.attributes.pattern));
    }
  }

  private addRequiredValidator(control: AbstractControl, item: InputItemBaseModel): void {
    if (item.attributes?.required !== true) {
      return;
    }

    let validator: ValidatorFn;

    switch (item.type) {
      case 'checkbox':
        validator = Validators.requiredTrue;

        break;
      case 'checkboxes':
        validator = CheckboxesValidator.required;

        break;
      default:
        validator = Validators.required;
    }

    control.addValidators(validator);
  }

  private addPostalCodeValidator(control: AbstractControl, item: InputItemBaseModel): void {
    if (item.validators?.['postalCode'] === true) {
      control.addValidators(PostalCodeValidator.validate);
    }
  }

  private addMinValidator(control: AbstractControl, item: InputItemBaseModel): void {
    if (item.attributes?.min === undefined) {
      return;
    }

    if (item.type === 'date') {
      control.addValidators(
        DatetimeValidator.minDate(item.attributes.min),
      );
    }
  }

  private addMaxValidator(control: AbstractControl, item: InputItemBaseModel): void {
    if (item.attributes?.max === undefined) {
      return;
    }

    if (item.type === 'date') {
      control.addValidators(
        DatetimeValidator.maxDate(item.attributes.max),
      );
    }
  }

  private addDateValidator(control: AbstractControl, item: InputItemModel): void {
    if (item.type !== 'date') {
      return;
    }

    control.addValidators(DateFilterValidator.validateFn(item));
  }

  private addFileValidator(control: AbstractControl, item: InputItemModel): void {
    if (item.type !== 'file') {
      return;
    }

    control.addValidators(FileValidator.validateFn(item));
  }

  private addFileMinCountValidator(control: AbstractControl, item: InputItemBaseModel): void {
    if (item.type !== 'file') {
      return;
    }

    const minCount: number | undefined = item.attributes?.minCount;

    if (minCount !== undefined && minCount > 0) {
      control.addValidators(FileCountValidator.minCount(minCount));
    }
  }
}
